import React from 'react'
import NoticeTextInput from "../../components/inputs/NoticeTextInput";


function AdditionalInfoData(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;

    return (<>
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("info")}
            multiline
        />
    </>)
}

AdditionalInfoData.propTypes = {};

export default AdditionalInfoData;
